import type { TransactionList } from "@/client";
import { ChecksView } from "@/features/checks/ChecksView";
import { DaePaymentsView } from "@/features/dae/DaePaymentsView";
import { OverviewView } from "@/features/dashboard/OverviewView";
import { SupplierPaymentsView } from "@/features/dashboard/SupplierPaymentsView";
import { FreightsView } from "@/features/freights/FreightsView";
import { OperatingExpensesView } from "@/features/operating-expenses/OperatingExpensesView";
import { ReceiptsView } from "@/features/receipts/ReceiptsView";
import { SuppliersView } from "@/features/suppliers/SuppliersView";
import { TreasuryView } from "@/features/treasury/TreasuryView";

export type DashboardView =
	| "OVERVIEW"
	| "SUGAR"
	| "PACKAGING"
	| "FREIGHT"
	| "GNRE"
	| "CHECKS"
	| "RECEIPTS"
	| "TREASURY"
	| "EXPENSES"
	| "SUPPLIERS";

export function Dashboard({ data, view }: { data: TransactionList; view: DashboardView }) {
	return <DashboardContent data={data} view={view} />;
}

function DashboardContent({ data, view }: { data: TransactionList; view: DashboardView }) {
	switch (view) {
		case "OVERVIEW":
			return <OverviewView data={data} />;
		case "SUGAR":
			return <SupplierPaymentsView data={data} categoryId="sugar" />;
		case "PACKAGING":
			return <SupplierPaymentsView data={data} categoryId="packaging" />;
		case "FREIGHT":
			return <FreightsView data={data} />;
		case "GNRE":
			return <DaePaymentsView />;
		case "CHECKS":
			return <ChecksView data={data} />;
		case "RECEIPTS":
			return <ReceiptsView />;
		case "TREASURY":
			return <TreasuryView />;
		case "EXPENSES":
			return <OperatingExpensesView data={data} />;
		case "SUPPLIERS":
			return <SuppliersView data={data} />;
		default:
			throw new Error("Área da dashboard inválida");
	}
}
